import React from 'react';
import { Tag } from '../tag/tag-component';
import { Link } from 'gatsby';

export interface IArticlePreview {
  image: {
    src: string;
    alt: string;
  };
  title: string;
  description: string;
  category: string;
  timeToRead: string;
  createdAt: string;
  link: string;
}

export default function ArticlePreviewCard({
  image,
  timeToRead,
  createdAt,
  title,
  description,
  category,
  link,
}: IArticlePreview) {
  return (
    <Link to={link} className="article-preview-card">
      <div className="article-preview-card__header">
        <h4 className="article-preview-card__header__title">{title}</h4>
        <p className="article-preview-card__header__description">{description}</p>
        <Tag text={{ text: category }} />
      </div>
      <div className="article-preview-card__image">
        <img src={image.src} alt={image.alt} />
      </div>
      <div className="article-preview-card__footer">
        <div className="article-preview-card__footer__date">{formatDateToString(new Date(createdAt))}</div>
        <div className="article-preview-card__footer__time-to-read">{timeToRead}</div>
      </div>
    </Link>
  );
}

function formatDateToString(date: Date) {
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
